import React from 'react';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Lo compré el viernes. El lunes ya lo usé con una paciente nueva con resistencia a la insulina. No tuve que adaptar nada. Llegué a la consulta con un protocolo claro por primera vez en mucho tiempo.',
  author: 'Lic. en Nutrición, Buenos Aires. Recién recibida'
}, {
  quote: 'El Tomo de Salud Intestinal me cambió cómo trabajo con los pacientes con SII. Antes manejaba el FODMAP a medias porque nunca había tenido las 3 fases completas organizadas. Ahora tengo el protocolo entero y mis pacientes digestivos mejoran mucho más rápido.',
  author: 'Lic. en Nutrición, Córdoba. 3 años de práctica'
}, {
  quote: 'La guía de honorarios fue un golpe de realidad. Estaba cobrando menos de lo que me costaba atender. En dos semanas ajusté los precios con el sistema de actualización por inflación y no perdí ningún paciente.',
  author: 'Lic. en Nutrición, Rosario. Consultorio propio'
}, {
  quote: 'Los scripts de WhatsApp solos valieron el precio del bundle. Mis ausencias bajaron de 3 o 4 por semana a casi ninguna desde que implementé el protocolo de confirmación de 3 contactos.',
  author: 'Lic. en Nutrición, Mendoza. 5 años de práctica'
}, {
  quote: 'Antes del Arsenal pasaba horas armando planes que al final no me daban seguridad. Ahora tengo una estructura clara para cada paciente, para cada patología, para cada situación. Es un antes y un después para los que recién arrancamos.',
  author: 'Lic. en Nutrición, La Plata. Primer año de práctica'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-brand-teal text-white" data-id="element-192">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-16 text-center" data-id="element-194">
          Lo que dicen los que ya lo usan
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-195">
          {testimonials.map((t, i) => <div key={i} className={`bg-white/10 p-8 rounded-2xl border border-white/20 backdrop-blur-sm ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-196">
              <Quote className="w-8 h-8 text-brand-accent mb-4 opacity-50" data-id="element-197" />
              <p className="text-lg leading-relaxed mb-6 font-medium" data-id="element-198">
                "{t.quote}"
              </p>
              <p className="text-brand-tealLight font-bold text-sm uppercase tracking-wider" data-id="element-199">
                — {t.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}